
import XTable from 'vux/src/components/x-table/index.vue'

import counter from '../common/counter.vue';
import checkBox from '../common/checkBox.vue';
import recommend from './recommend.vue';
import noGoods from './noGoods.vue';
export default {
components: {
XTable,
counter,
checkBox,
recommend,
noGoods
},
data() {
return {
dealType: 1,
checkAll: false,
selectedQuantity: 0,
totalPrice: 0,
list: [],
releaseList: [], //已失效商品，下架商品
defaultAddress: '',
number: 1,
goods: {},
limit: false
};
},
computed: {
carBadge() {
return this.$store.state.carBadge;
},

token() {
return this.$store.state.token;
}
},
watch: {
token(newVal) {
if (newVal) {
this.getAddress();
this.loadList();
} else {
this.checkAll = false;
this.selectedQuantity = 0;
this.totalPrice = 0;
this.list = [];
this.defaultAddress = '';
}
},
list: {
handler() {
sessionStorage.shoppingCartList = JSON.stringify(this.list);
},
deep: true
},
releaseList: {
handler() {
sessionStorage.releaseList = JSON.stringify(this.releaseList);
},
deep: true
}
},
methods: {

checkAllChangeHandle() {
this.checkAll = this.checkAll ? false : true;
let that = this;
this.list.forEach(item => {
item.check = that.checkAll;
});
this.accountTotalPrice();
},

checkChangeHandle(index) {
this.list[index].check = this.list[index].check ? false : true;
var unCheckList = this.list.filter(item => {
return !item.check;
});
if (unCheckList.length > 0) {
this.checkAll = false;
} else {
this.checkAll = true;
}
this.accountTotalPrice();
},

numChangeHandle(item, value) {
if (this.limit) {
this.limit = false;
return;
}
let that = this;
let data = {
orderCartId: item.orderCartId,
number: value
};
that.$axios.post('/api/v1.0/lonbonShop/updateOrderCart', that.qs.stringify(data)).then(function (response) {
if (response.status == 200) {
}
});
this.accountTotalPrice();
},

accountTotalPrice() {
var totalPrice = 0;
var selectedQuantity = 0;
this.list.forEach(item => {
if (item.check) {
totalPrice += item.number * item.sellingPrice;
selectedQuantity += 1;
}
});
this.selectedQuantity = selectedQuantity;
this.totalPrice = totalPrice;
},

deleteGoods() {
var orderCartIdList = [];
var unCheckList = this.list.filter(item => {
if (item.check) {
orderCartIdList.push(item.orderCartId);
}
return !item.check;
});
let that = this;
this.ajaxDelete(orderCartIdList, 1, function () {
that.list = unCheckList;
that.accountTotalPrice();
});
},

clearReleaseList() {
var orderCartIdList = this.releaseList.map(item => {
return item.orderCartId;
});
let that = this;
this.ajaxDelete(orderCartIdList, 2, function () {
that.releaseList = [];
});
},

onButtonClick(item, index) {
let that = this;
var orderCartIdList = [item.orderCartId];
this.ajaxDelete(orderCartIdList, 1, function () {
that.list.splice(index, 1);
that.accountTotalPrice();
});
},

ajaxDelete(orderCartIdList, type, callback) {
let that = this;
if (!orderCartIdList || orderCartIdList.length <= 0) {
that.$vux.toast.text('您还没有选择宝贝哦');
return false;
} else {
var content = `确定删除这${orderCartIdList.length}个宝贝？`;
if (type == 2) {
content = '确认清空失效宝贝吗？';
}
that.$vux.confirm.show({
content: content,
cancelText: '我再想想',
confirmText: '删除',
title: '提示',
onConfirm() {
let data = {
orderCartIdList: JSON.stringify(orderCartIdList)
};
that.$axios.post('/api/v1.0/lonbonShop/deteleOrderCart', that.qs.stringify(data)).then(function (response) {
if (response.status == 200) {
callback();
that.$store.state.APPPAGE.getOrderCartNum();
}
});
}
});
}
},
doRefresh(done) {
this.currentPage = 1;
this.loadList();
this.$store.state.APPPAGE.getOrderCartNum();
this.checkAll = false;
this.totalPrice = 0;
setTimeout(() => {
done && done(true);
}, 1000);
},
loadList() {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/orderCart', {
params: {
shopperId: that.$store.state.userInfo.shopperId
}
})
.then(function (response) {
if (response.status == 200) {
var list = [],
releaseList = [];
response.body.forEach(item => {
item.poster = item.photo;
item.check = false;
if (item.isRelease == 1) {
list.push(item);
} else {
releaseList.push(item);
}
});
that.list = list;
that.releaseList = releaseList;

}
});
},
getAddress() {
let that = this;
that.$axios
.get('/api/v1.0/lonbonShop/receiverAddress', {
params: {
shopperId: that.$store.state.userInfo.shopperId
}
})
.then(function (res) {
if (res.status == 200) {
var address = '';
res.body.forEach(item => {
if (item.defaultAddress == 1) {
address = item.regionDesc.replace(/\s/g, '') + item.address;
}
});
if (!address && res.body.length > 0) {
var one = res.body[0];
address = one.regionDesc.replace(/\s/g, '') + one.address;
}
that.defaultAddress = address;
}
});
},
toDetail(item) {
this.$router.push('/goodsDetail?backPath=' + this.$route.path + '&goodsId=' + item.goodsId);
},
accountOrder() {
var checkList = this.list.filter(item => {
return item.check;
});
if (checkList && checkList.length > 0) {
sessionStorage.readyBuyGoods = JSON.stringify(checkList);
this.$router.push('/settlement');
} else {
this.$vux.toast.text('您还没有选择宝贝哦');
}
},
updateShoppingCart() {
this.loadList();
this.limit = true;
}
},
created() {
if (sessionStorage.shoppingCartList) {
this.list = JSON.parse(sessionStorage.shoppingCartList);
}
if (sessionStorage.releaseList) {
this.releaseList = JSON.parse(sessionStorage.releaseList);
}
},
mounted() {
if (sessionStorage.token) {
this.loadList();
} else {
this.$store.state.pcLoginShow = true;
}
}
};



// WEBPACK FOOTER //
// ./src/pcComponents/shoppingCart/index.vue